export default axiosInstance => {
  async function query({ jwt }) {
    return (
      await axiosInstance({
        method: "get",
        url: "/liff/notifications",
        headers: { jwt }
      })
    ).data;
  }

  async function updateOne({ jwt, notifications }) {
    return (
      await axiosInstance({
        method: "put",
        url: "/liff/notifications",
        headers: { jwt },
        data: { notifications }
      })
    ).data;
  }

  return {
    query,
    updateOne
  };
};
